(function ($) {
    function StickyCTA(cta, ph) {
        this.cta = cta;
        this.ph = ph;
        this.close = cta.find('a.close-me');
        this.no_stick = false;

        this.adjustPlaceholderHeight = function () {
            ph.css('height', cta.height() + 'px');
        }.bind(this);

        this.setSticky = function () {
            this.cta.addClass('sticky');
            this.ph.addClass('placed');
        }.bind(this);

        this.setStatic = function () {
            this.cta.removeClass('sticky');
            this.ph.removeClass('placed');
        }.bind(this);

        this.disable = function (e) {
            e.preventDefault();
            this.no_stick = true;
            this.close.remove();
            this.setStatic();
        }.bind(this);

        this.scroll = function () {
            this.adjustPlaceholderHeight();
            var scrollTop = $(window).scrollTop();
            var scrollBottom = scrollTop + $(window).height();

            if (scrollBottom >= (this.ph.offset().top + this.ph.height()) || this.no_stick) {
                this.setStatic(this);
            } else {
                this.setSticky(this);
            }
        }.bind(this);

        this.init = function () {
            $(window).on('load', function () {
                this.scroll();
            }.bind(this));
            $(window).resize(function () {
                this.scroll(this);
            }.bind(this));
            $(window).scroll(function () {
                this.scroll(this);
            }.bind(this));
            this.scroll(this);
        }.bind(this);
    }

    $(document).ready(function () {
        var placeholder = $('.sticky-cta-ph');
        var cta_container = $('.sticky-cta');

        if (cta_container.length && placeholder.length) {
            var cta = new StickyCTA(cta_container, placeholder);
            cta.init();
        }
    });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/fixed-callout.js